export default "__VITE_ASSET__642095fc__"